import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import PageHeader from '../../../components/common/PageHeader';
import { Link } from 'react-router';
import LevelSettingsPage from './LevelSettingsPage';
import CronSettingsPage from './CronSettingsPage';
import EsetMappingConfig from '../ESET/EsetMappingConfig';
import GeneralSettingsPage from './GeneralSettingsPage';
import OvhSettingsPage from './OvhSettingsPage';
import CentreonSettingsPage from './CentreonSettingsPage';
import VcspSettingsPage from './VcspSettingsPage';

function SigniticSettingsLink() {
  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
      <Stack spacing={1.5} alignItems="flex-start">
        <Typography variant="h6" sx={{ fontWeight: 800 }}>Signitic</Typography>
        <Typography variant="body2" color="text.secondary">
          Les clés API Signitic sont actuellement gérées par client depuis l'écran Signitic.
        </Typography>
        <Button component={Link} to="/dashboard/signitic" variant="contained">
          Ouvrir Signitic
        </Button>
      </Stack>
    </Paper>
  );
}

const sectionTitles = {
  general: 'Général',
  signitic: 'Signitic',
  level: 'Level.io',
  ovh: 'OVH',
  centreon: 'Centreon',
  vcsp: 'VCSP',
  cron: 'Cron',
  eset: 'ESET',
};

export default function SettingsPage({ section = 'general' }) {
  const renderContent = () => {
    if (section === 'general') return <GeneralSettingsPage />;
    if (section === 'level') return <LevelSettingsPage />;
    if (section === 'ovh') return <OvhSettingsPage />;
    if (section === 'centreon') return <CentreonSettingsPage />;
    if (section === 'vcsp') return <VcspSettingsPage />;
    if (section === 'cron') return <CronSettingsPage />;
    if (section === 'eset') return <EsetMappingConfig />;
    if (section === 'signitic') return <SigniticSettingsLink />;
    return <GeneralSettingsPage />;
  };

  return (
    <Box sx={{ p: 3, maxWidth: 1280, mx: 'auto' }}>
      <Stack spacing={2.5}>
        <PageHeader section="Paramètres" title={sectionTitles[section] || 'Paramètres'} />

        {renderContent()}
      </Stack>
    </Box>
  );
}
